/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import * as apiEngine from '@/api/engine'
import * as types from './mutation-types'

export default {
  async getInfo({ commit, dispatch }) {
    try {
      commit(types.LOADING_INFO, true)
      const info = await apiEngine.getEngineInfo()
      commit(types.UPDATE_ENGINE_INFO, info)
    } catch (e) {
      dispatch('notification/error', 'Failed to retrieve the engine info.', { root: true })
    } finally {
      commit(types.LOADING_INFO, false)
    }
  },

  async getStatus({ commit, dispatch }) {
    try {
      const { on } = await apiEngine.getEngineStatus()
      commit(types.SET_ENGINE_STATUS, on)
    } catch (e) {
      dispatch('notification/error', 'Failed to retrieve the engine status.', { root: true })
    }
  },

  async restartEngine({ commit, dispatch }) {
    try {
      commit(types.LOADING_ENGINE, true)
      const { restarted } = await apiEngine.restartEngine()
      commit(types.SET_ENGINE_STATUS, restarted)
    } catch (e) {
      dispatch('notification/error', 'Failed to restart the engine.', { root: true })
    } finally {
      commit(types.LOADING_ENGINE, false)
    }
  },

  async startEngine({ commit, dispatch }) {
    try {
      commit(types.LOADING_ENGINE, true)
      const { started } = await apiEngine.startEngine()
      commit(types.SET_ENGINE_STATUS, started)
    } catch (e) {
      dispatch('notification/error', 'Failed to start the engine.', { root: true })
    } finally {
      commit(types.LOADING_ENGINE, false)
    }
  },

  async stopEngine({ commit, dispatch }) {
    try {
      commit(types.LOADING_ENGINE, true)
      const { stopped } = await apiEngine.stopEngine()
      commit(types.SET_ENGINE_STATUS, !stopped)
    } catch (e) {
      dispatch('notification/error', 'Failed to stop the engine.', { root: true })
    } finally {
      commit(types.LOADING_ENGINE, false)
    }
  },
}
